import React from 'react'

import { Navbar, Footer } from '../../../components';
import { Article5Doc } from '../individual';

export default function Article5() {
  return (
    <div className='emas__article1'>
        <Navbar />
        <Article5Doc />
        <Footer />
    </div>
  )
}
